const verticalTabs = () => {
	const tabs = document.querySelector(".servicios.custom-vertical-tabs");
	if (!tabs) return;

	const services = tabs.querySelectorAll(".servicio");
	const imageWrapper = tabs.parentElement?.querySelector(".servicio__item__img-wrapper");
	const images = imageWrapper?.querySelectorAll(".servicio__item__img") ?? [];
	const mobileMediaQuery = window.matchMedia("(max-width: 991.98px)");
	const imageWrapperPlaceholder = document.createComment("servicios-media-position");

	if (imageWrapper) {
		imageWrapper.before(imageWrapperPlaceholder);
	}

	const restoreImageWrapper = () => {
		if (!imageWrapper || imageWrapper.previousSibling === imageWrapperPlaceholder) return;

		imageWrapperPlaceholder.after(imageWrapper);
	};

	const placeImageWrapper = (service) => {
		if (!imageWrapper) return;

		if (!mobileMediaQuery.matches) {
			restoreImageWrapper();
			return;
		}

		// When the mobile accordion is closed, leave the media inside its now
		// hidden panel so it does not reappear above the list of services.
		if (!service) return;

		service.querySelector(".servicio__wrapper")?.prepend(imageWrapper);
	};

	const updateVimeoUrl = (iframe, shouldAutoplay = false) => {
		const src = iframe.getAttribute("src");
		if (!src) return;

		try {
			const url = new URL(src, window.location.href);
			const isVimeo = url.hostname.includes("vimeo.com");

			iframe.setAttribute("allow", "autoplay; fullscreen; picture-in-picture");

			if (!isVimeo) return;

			url.searchParams.set("autoplay", shouldAutoplay ? "1" : "0");
			url.searchParams.set("muted", "1");
			url.searchParams.set("loop", "1");
			url.searchParams.set("autopause", "0");
			url.searchParams.set("playsinline", "1");
			url.searchParams.set("controls", "0");
			url.searchParams.set("title", "0");
			url.searchParams.set("byline", "0");
			url.searchParams.set("portrait", "0");
			url.searchParams.set("background", "1");
			url.searchParams.set("api", "1");
			url.searchParams.set("dnt", "1");

			const nextSrc = url.toString();

			if (iframe.src !== nextSrc) {
				iframe.src = nextSrc;
			}
		} catch (error) {
			iframe.setAttribute("allow", "autoplay; fullscreen; picture-in-picture");
		}
	};

	const sendVimeoCommand = (iframe, command) => {
		const src = iframe.getAttribute("src") || "";
		if (!src.includes("vimeo.com") || !iframe.contentWindow) return;

		iframe.contentWindow.postMessage({ method: command }, "*");
	};

	const prepareVideo = (video, shouldAutoplay) => {
		video.muted = true;
		video.loop = true;
		video.playsInline = true;
		video.controls = false;
		video.autoplay = shouldAutoplay;
		video.setAttribute("muted", "");
		video.setAttribute("loop", "");
		video.setAttribute("playsinline", "");
		video.removeAttribute("controls");

		if (shouldAutoplay) {
			video.setAttribute("autoplay", "");
		} else {
			video.removeAttribute("autoplay");
		}
	};

	const setMediaPlayback = (image, shouldPlay) => {
		image.querySelectorAll("video").forEach((video) => {
			if (shouldPlay) {
				video.play().catch(() => {});
			} else {
				video.pause();
			}
		});

		image.querySelectorAll("iframe").forEach((iframe) => {
			sendVimeoCommand(iframe, shouldPlay ? "play" : "pause");

			if (shouldPlay) {
				window.setTimeout(() => sendVimeoCommand(iframe, "play"), 250);
			}
		});
	};

	const prepareVideoMedia = (activeIndex) => {
		images.forEach((image, imageIndex) => {
			const isActive = imageIndex === activeIndex;

			image.querySelectorAll("video").forEach((video) => {
				prepareVideo(video, isActive);
			});

			image.querySelectorAll("iframe").forEach((iframe) => {
				updateVimeoUrl(iframe, isActive);

				iframe.addEventListener("load", () => {
					if (image.classList.contains("active")) {
						setMediaPlayback(image, true);
					}
				});
			});
		});
	};

	const activateImage = (index) => {
		if (!images.length) return;

		images.forEach((image, imageIndex) => {
			const isActive = imageIndex === index;
			image.classList.toggle("active", isActive);
			setMediaPlayback(image, isActive);
		});

		placeImageWrapper(index >= 0 ? services[index] : null);
	};

	const deactivateImages = () => {
		activateImage(-1);
	};

	const closeTooltips = () => {
		tabs.querySelectorAll(".boton-servicio.is-tooltip-active").forEach((button) => {
			button.classList.remove("is-tooltip-active");
		});
	};

	let hoverIntentTimer;

	const clearHoverIntent = () => {
		window.clearTimeout(hoverIntentTimer);
		hoverIntentTimer = undefined;
	};

	services.forEach((service, index) => {
		const setActiveTab = (canCloseActive = false) => {
			const isActive = service.classList.contains("active");

			if (isActive && !canCloseActive) return;

			services.forEach((item) => {
				item.classList.remove("active");
				item.querySelector(".servicio__wrapper")?.classList.remove("active");
			});
			closeTooltips();

			if (isActive) {
				deactivateImages();
				return;
			}

			service.classList.add("active");
			service.querySelector(".servicio__wrapper")?.classList.add("active");
			activateImage(index);

			if (window.innerWidth < 768) {
				const top = service.getBoundingClientRect().top + window.scrollY - 55;

				window.scrollTo({
					top,
					behavior: "smooth",
				});
			}
		};

		const header = service.querySelector(".servicio__header");
		header?.addEventListener("click", () => {
			clearHoverIntent();
			setActiveTab(true);
		});
		header?.addEventListener("mouseenter", () => {
			if (window.innerWidth <= 1300) return;
			if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

			clearHoverIntent();
			hoverIntentTimer = window.setTimeout(() => setActiveTab(false), 120);
		});
		header?.addEventListener("mouseleave", clearHoverIntent);
	});

	tabs.addEventListener("click", (event) => {
		const button = event.target.closest(".boton-servicio");
		if (!button || !tabs.contains(button)) return;

		event.stopPropagation();

		if (window.innerWidth > 1300) return;

		const isActive = button.classList.contains("is-tooltip-active");
		closeTooltips();
		button.classList.toggle("is-tooltip-active", !isActive);
	});

	document.addEventListener("click", (event) => {
		if (tabs.contains(event.target)) return;
		closeTooltips();
	});

	const activeIndex = Array.from(services).findIndex((service) => service.classList.contains("active"));
	const initialIndex = activeIndex >= 0 ? activeIndex : 0;
	prepareVideoMedia(initialIndex);
	activateImage(initialIndex);

	mobileMediaQuery.addEventListener("change", () => {
		const currentIndex = Array.from(services).findIndex((service) => service.classList.contains("active"));
		placeImageWrapper(currentIndex >= 0 ? services[currentIndex] : null);
	});
};

export { verticalTabs };
